import { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getFeedbackById, saveFeedbackReply } from '../api/feedbackApi'
import { appToast } from '../../../../components/AppToast'

export default function useFeedbackReply() {
  const { id } = useParams()
  const navigate = useNavigate()

  const [feedbackItem, setFeedbackItem] = useState(null)
  const [replyText, setReplyText] = useState('')
  const [loading, setLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  const loadRecord = useCallback(async () => {
    if (!id) return
    setLoading(true)
    try {
      const data = await getFeedbackById(id)
      setFeedbackItem(data)
      setReplyText(data.reply || '')
    } catch (e) {
      console.error('Failed to fetch feedback entry', e)
      appToast.error('Feedback entry not found.')
      navigate('/cloud/feedback/list', { replace: true })
    } finally {
      setLoading(false)
    }
  }, [id, navigate])

  useEffect(() => {
    loadRecord()
  }, [loadRecord])

  const handleSave = async () => {
    if (!replyText.trim()) {
      appToast.error('Please enter a reply message before saving.')
      return false
    }

    setIsSaving(true)
    try {
      await saveFeedbackReply(id, replyText)
      appToast.success('Entry Saved Successfully')
      navigate('/cloud/feedback/list')
      return true
    } catch (e) {
      console.error('Failed to save feedback reply', e)
      appToast.error('Error Saving Entry')
      return false
    } finally {
      setIsSaving(false)
    }
  }

  const handleCancel = () => {
    navigate('/cloud/feedback/list')
  }

  return {
    state: {
      id,
      feedbackItem,
      replyText,
      loading,
      isSaving,
    },
    actions: {
      setReplyText,
      handleSave,
      handleCancel,
    },
  }
}
